import { LogLevelType } from '@bannerflow/sentinel-logger';

export function getLogLevelParam(): LogLevelType {
    const url = new URL(window.location.href);
    const logLevel = url.searchParams.get('log') || '';
    return logLevel as LogLevelType;
}
